/* FT-Redesign: Indian lakh/crore digit grouping.
   Shopify has no native lakh-grouping money filter (amount_with_comma_separator is the
   EUROPEAN format). Store setting gives us "Rs132,300"; this rewrites it to "Rs1,32,300".
   Runs on text nodes only, never touches inputs/forms/values used by cart JS. */
(function () {
  var RUPEE = '₹';

  function groupIndian(digits) {
    if (digits.length <= 3) return digits;
    var last3 = digits.slice(-3);
    var rest = digits.slice(0, -3);
    rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
    return rest + ',' + last3;
  }

  // Matches Rs<digits with optional western commas>, optional decimals
  var RE = new RegExp(RUPEE + '\\s?(\\d[\\d,]*)(\\.\\d+)?', 'g');

  function fixText(s) {
    return s.replace(RE, function (full, intPart, dec) {
      var digits = intPart.replace(/,/g, '');
      if (digits.length <= 3) return full;
      return RUPEE + groupIndian(digits) + (dec || '');
    });
  }

  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, NOSCRIPT: 1 };

  function walk(root) {
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf(RUPEE) === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (!p || SKIP[p.nodeName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [], n;
    while ((n = w.nextNode())) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) {
      var t = nodes[i].nodeValue;
      var f = fixText(t);
      if (f !== t) nodes[i].nodeValue = f;
    }
  }

  function run() { try { walk(document.body); } catch (e) {} }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 120); }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  try {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  } catch (e) {}
})();
